var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from "./IconButton";
import { FaGithub, FaTelegramPlane, FaMediumM, FaTwitter, } from "react-icons/fa";
import { TELEGRAM_URL, TWITTER_URL, MEDIUM_URL, GITHUB_URL, } from "../../config";
import { useCallback } from "react";
export var GithubButton = function () {
    return (_jsx(SocialMediaButton, __assign({ href: GITHUB_URL }, { children: _jsx(FaGithub, { size: "32px" }, void 0) }), void 0));
};
export var MediumButton = function () {
    return (_jsx(SocialMediaButton, __assign({ href: MEDIUM_URL }, { children: _jsx(FaMediumM, { size: "32px" }, void 0) }), void 0));
};
export var TelegramButton = function () {
    return (_jsx(SocialMediaButton, __assign({ href: TELEGRAM_URL }, { children: _jsx(FaTelegramPlane, { size: "32px" }, void 0) }), void 0));
};
export var TwitterButton = function () {
    return (_jsx(SocialMediaButton, __assign({ href: TWITTER_URL }, { children: _jsx(FaTwitter, { size: "32px" }, void 0) }), void 0));
};
export var SocialMediaButton = function (_a) {
    var href = _a.href, children = _a.children;
    var onClick = useCallback(function () {
        var newWindow = window.open(href, "_blank", "noopener,noreferrer");
        if (newWindow) {
            newWindow.opener = null;
        }
    }, [href]);
    return _jsx(IconButton, __assign({ onClick: onClick }, { children: children }), void 0);
};
